export default function headerScript() {
    const body = document.body;
    const searchToggle = document.querySelector('.c-header__search-toggle');
    const searchContainer = document.querySelector('.c-header__search');
    const searchForm = document.querySelector('.c-header__search-form');
    const mobileToggle = document.querySelector('.c-header__mobile-toggle');
    
    if (searchToggle && searchForm) {
        searchToggle.addEventListener('click', () => {
            if (searchForm.classList.contains('c-header__search-form--active')) {
                searchForm.classList.remove('c-header__search-form--active');
            } else {
                searchForm.classList.add('c-header__search-form--active');
            }
        });
    }
  
    if(mobileToggle) {
        mobileToggle.addEventListener('click', () => {
            if (body.classList.contains('c-mobile-nav-active')) {
                body.classList.remove('c-mobile-nav-active');
            } else {
                body.classList.add('c-mobile-nav-active');
            }
        });
    }

    // I'm using "click" but it works with any event
    document.addEventListener('click', event => {
        const isClickInside = searchContainer.contains(event.target)

        if (!isClickInside) {
            searchForm.classList.remove('c-header__search-form--active');
        }
    })
}
  